import { WeekDayNames } from './hours';
import { IUserFull } from './user';

export const ALL_LEAVE_POLICY_TYPES = [
  'bereavement',
  'custom',
  'holiday',
  'office',
  'ooo',
  'parental',
  'personal',
  'remote',
  'sick',
  'unpaid',
  'vacation'
] as const;

export type LeavePolicyType =
  | 'bereavement'
  | 'custom'
  | 'holiday'
  | 'office'
  | 'ooo'
  | 'parental'
  | 'personal'
  | 'remote'
  | 'sick'
  | 'unpaid'
  | 'vacation';

export enum LeavePolicyTypeDisplay {
  bereavement = 'Bereavement',
  custom = 'Custom',
  holiday = 'Holiday',
  office = 'Office',
  ooo = 'OOO',
  parental = 'Parental',
  personal = 'Personal',
  remote = 'Remote',
  sick = 'Sick',
  unpaid = 'Unpaid',
  vacation = 'Vacation'
}

export type LeavePolicy = {
  id: string;
  title: string;
  description: string;
  allotted: number | null;
  is_approvable: boolean;
  office_days:
    | {
        [day in WeekDayNames]:
          | 'weekly'
          | 'month_first'
          | 'month_second'
          | 'month_third'
          | 'month_fourth';
      }
    | {};
  office_ids: string[];
  policy_type: LeavePolicyType;
  renewal: 'weekly' | 'annually' | 'monthly' | null;
  renewal_date: string | null;
  renewal_on_hire_date: boolean;
  hire_date_minimum_days: null | number;
  team_ids: string[] | null;
  user_ids: string[] | null;
  time_zone_id: string;
};

export type LeavePolicyParams = {
  workPolicyType: LeavePolicyType[];
  office: string[];
  team: string[];
  user: string[];
  tz: string;
};

export type LeaveRequestsParams = {
  workPolicyType: LeavePolicyType[];
  status: string[];
  tz: string;
  start?: string;
  end?: string;
};

export type IAttendanceRequestType = {
  policy_type: LeavePolicyType;
  status: 'pending' | 'accepted' | 'rejected';
  amount_requested: number | null;
  ends: string;
  starts: string;
  id: string;
  reason: string | null;
  responded_comments: string | null;
  user: IUserFull;
  time_zone_id: string;
};

export type ILeaveUseRequest = {
  policy_type: LeavePolicyType;
  starts: string;
  ends: string;
  reason: string;
  time_zone_id: string;
};
